"use client";

import { DbConnection } from "@libum-llc/glaci-spacetime/module_bindings";

/** The bindings' connection type for the Glaci runtime SpacetimeDB. */
export type RuntimeConnection = DbConnection;

/** Coordinates needed to open a connection to an org's runtime. */
export type RuntimeTarget = { uri: string; module: string };

/**
 * Open a connection to an org's Glaci runtime SpacetimeDB for insight
 * subscriptions. Authenticates with the caller's OpenAuth JWT when provided —
 * the runtime links the connection to a user, which per-user insight views
 * require — and falls back to anonymous otherwise. Compression is disabled
 * to avoid the WebKit gzip decoding issue.
 */
export function connectGlaciRuntime(
  target: RuntimeTarget,
  handlers: {
    onConnect: (conn: RuntimeConnection) => void;
    onError: (err: unknown) => void;
    /** Fires when an ESTABLISHED connection drops (not for connect failures —
     * those surface via onError). */
    onDisconnect?: () => void;
  },
  token?: string | null,
): { disconnect: () => void } {
  const handle = DbConnection.builder()
    .withUri(target.uri)
    .withDatabaseName(target.module)
    .withCompression("none")
    .withToken(token ?? undefined)
    .onConnect((conn) => handlers.onConnect(conn))
    .onConnectError((_ctx, err) => handlers.onError(err))
    .onDisconnect(() => handlers.onDisconnect?.())
    .build();

  return { disconnect: () => handle.disconnect() };
}
